import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/access/applications')({
  beforeLoad: () => {
    throw redirect({
      search: { current: 1, pageSize: 20 },
      to: '/access/accounts',
      replace: true
    })
  }
})
